// extracted by mini-css-extract-plugin
export default {"tip_content":"TiersExplained_tip_content__z6+oC","desc":"TiersExplained_desc__fOr3F","t1":"TiersExplained_t1__ka3R7","t2":"TiersExplained_t2__rryBT","m":"TiersExplained_m__7ZeCO"};